export default "__VITE_ASSET__CxPO5XYY__"